import axios from '@axios'
import baseConfig from "../../../baseConfig";
import {initialAbility} from "@/plugins/acl/config";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    permissions: 0,
  },
  getters: {
    getPermissions(state) {
      return state.permissions
    },
  },
  mutations: {
    setAuthorization(state, { permission }) {
      state.permissions = permission
    },
  },
  actions: {
    async getAuthorization({ commit }) {
      if (window.sessionStorage.getItem("login")==="yes") {
        try {
          const permission = await axios.get(baseConfig.baseUrl + 'permissions/' + localStorage.getItem("currentOrganizationId") + "?defaultOrganizationId=" + localStorage.getItem("currentOrganizationId"))
          commit('setAuthorization', {permission})
        } catch (err) {
          console.log("you have no permission")
        }
      }else{
        if (history.length!==1) {
          localStorage.removeItem('accessToken')

          // Remove userData & Ability from localStorage
          localStorage.removeItem('userData')
          localStorage.removeItem('userAbility')


          // Redirect to login page
          top.location = "/login"
        }else {
          try {
            const permission = await axios.get(baseConfig.baseUrl + 'permissions/' + localStorage.getItem("currentOrganizationId") + "?defaultOrganizationId=" + localStorage.getItem("currentOrganizationId"))
            commit('setAuthorization', {permission})
          } catch (err) {
            console.log("you have no permission")
          }
        }
      }

    },
  },
}
